import React from "react";
import {
  Card,
  Box,
  Typography,
  Stack,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import MuestraArchivosCellLite from "./MuestraArchivosCellLite";

const MuestraCard = ({ muestra, onSelect }) => {
  const { t } = useTranslation();
  const notArrived =
    muestra.ESTADO_NOMBRE === "PDTE LLEGAR" ||
    !muestra.FECHA_RECEPCION ||
    new Date(muestra.FECHA_RECEPCION) > new Date();

  return (
    <Card
      sx={{
        cursor: "pointer",
        borderRadius: 4,
        overflow: "hidden",
        boxShadow: "0 8px 26px rgba(0,0,0,0.10)",
        transition: "all 0.3s ease",
        opacity: 0,
        animation: "fadeInUp 0.6s ease forwards",
        "@keyframes fadeInUp": {
          from: { opacity: 0, transform: "translateY(20px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
        "&:hover": {
          transform: "translateY(-4px) scale(1.02)",
          boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
        },
      }}
      onClick={() => onSelect(muestra)}
    >
      {/* IMAGEN PRINCIPAL */}
      <Box
        sx={{
          width: "100%",
          height: 180,
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: 2,
          pt: 4,
        }}
      >
        <MuestraArchivosCellLite muestraId={muestra.id} />
      </Box>

      {/* CHIP + ICONO (COLOCADOS PERFECTAMENTE) */}
      <Box
        sx={{
          position: "relative",
          height: 0,
        }}
      >
        <Chip
          label={muestra.ESTADO_NOMBRE}
          size="small"
          sx={{
            position: "absolute",
            top: -165,
            left: 10,
            fontWeight: 600,
            bgcolor:
              muestra.ESTADO_NOMBRE === "Approved"
                ? "#c8f7c5"
                : muestra.ESTADO_NOMBRE === "Rejected"
                  ? "#ffb3b3"
                  : "#e0e0e0",
          }}
        />
        {/* Icono abrir drawer */}
        <Tooltip title="Open details">
          <IconButton
            sx={{
              position: "absolute",
              top: -165,
              right: 10,
              bgcolor: "rgba(255,255,255,0.7)",
              "&:hover": { bgcolor: "white" },
            }}
            onClick={(e) => {
              e.stopPropagation();
              onSelect(muestra);
            }}
          >
            <OpenInNewIcon />
          </IconButton>
        </Tooltip>{" "}
        {/* Estado */}
        {notArrived && (
          <Box
            sx={{
              position: "absolute",
              top: -30,
              right: 10,
              bgcolor: "rgba(255, 200, 0, 0.9)",
              color: "black",
              px: 1.2,
              py: 0.3,
              borderRadius: 2,
              fontSize: "0.75rem",
              fontWeight: 700,
            }}
          >
            Pending Arrival
          </Box>
        )}
      </Box>

      {/* CONTENIDO */}
      <Box sx={{ p: 2, pt: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,

            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {muestra.MUESTRA}
        </Typography>
        <Typography variant="body2" sx={{ color: "#90b2b7", mb: 1 }}>
          {muestra.NombreCliente}
        </Typography>

        <Typography variant="body1" sx={{ opacity: 0.7, mb: 1 }}>
          {muestra.NOMBRE_CLIENTE} — {muestra.TALLA_NOMBRE}
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              backgroundColor: muestra.COLOR_HEX,
              border: "1px solid #ccc",
            }}
          />
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {muestra.COLOR_PANTONE}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ mt: 1, opacity: 0.6 }}
        >
          <LocalShippingIcon fontSize="small" />
          <Typography variant="body2">{muestra.NOMBRE_PROVEEDOR}</Typography>
        </Stack>

        <Box sx={{ mt: 2 }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#90b2b7" }}
          >
            {t("Samples.FECHA_PREVISTA")}:{" "}
            {muestra.FECHA_PREVISTA
              ? new Date(muestra.FECHA_PREVISTA).toLocaleDateString("es-ES")
              : "-"}
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#b57cff" }}
          >
            {t("Samples.FECHA_PETICION")}:{" "}
            {muestra.FECHA_PETICION
              ? new Date(muestra.FECHA_PETICION).toLocaleDateString("es-ES")
              : "-"}
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#ff9900" }}
          >
            {t("Samples.FECHA_GET_SUPPLIER")}:{" "}
            {muestra.FECHA_GET_SUPPLIER
              ? new Date(muestra.FECHA_GET_SUPPLIER).toLocaleDateString("es-ES")
              : "-"}
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#ff0000" }}
          >
            {t("Samples.FECHA_ENVIO")}:{" "}
            {muestra.FECHA_ENVIO
              ? new Date(muestra.FECHA_ENVIO).toLocaleDateString("es-ES")
              : "-"}
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: "#00c2a3" }}
          >
            {t("Samples.FECHA_RECEPCION")}:{" "}
            {muestra.FECHA_RECEPCION
              ? new Date(muestra.FECHA_RECEPCION).toLocaleDateString("es-ES")
              : "-"}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default MuestraCard;
